import { render } from "./ModalConfirmRemoveHistoryPayment.vue?vue&type=template&id=a26740d2"
import script from "./ModalConfirmRemoveHistoryPayment.vue?vue&type=script&lang=js"
export * from "./ModalConfirmRemoveHistoryPayment.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__